import { render, staticRenderFns } from "./BiometricWhitelistPage.vue?vue&type=template&id=450a7c2c&scoped=true&"
import script from "./BiometricWhitelistPage.vue?vue&type=script&lang=js&"
export * from "./BiometricWhitelistPage.vue?vue&type=script&lang=js&"
import style0 from "./BiometricWhitelistPage.vue?vue&type=style&index=0&id=450a7c2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a7c2c",
  null
  
)

export default component.exports